module.exports = __webpack_public_path__ + "img/it-reference-01.82451f8f.webp";